import { useState } from 'react';
import { authenticate, authError, needsKey, needsTotp, type CustomerLoginResult } from '../lib/authSecurity';
import type { UserSessionResponse } from '../lib/userSession';

export function KeyLoginPrompt({ magicToken, hardwareRequired, onSuccess }: { magicToken: string; hardwareRequired: boolean; onSuccess: (session: UserSessionResponse) => void }) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const signIn = async () => {
    setPending(true); setError(null);
    try {
      const result = await authenticate<CustomerLoginResult>(false, { magicToken });
      if (needsKey(result) || needsTotp(result)) throw new Error('Key authentication is incomplete');
      onSuccess(result);
    } catch (err) { setError(authError(err)); } finally { setPending(false); }
  };
  return <div className="form-stack">
    <h2>{hardwareRequired ? 'Use your hardware security key' : 'Use your registered passkey'}</h2>
    <p className="helper-text">{hardwareRequired ? 'Your account requires a registered hardware key at every sign-in. Connect the key, then verify with its PIN or biometric.' : 'Your account requires a registered key or passkey at every sign-in, including email and Google. Verify with your device, PIN or biometric.'}</p>
    {error ? <div className="alert" role="alert">{error}</div> : null}
    <button className="button-primary" type="button" disabled={pending} onClick={signIn}>{pending ? 'Waiting for your key...' : hardwareRequired ? 'Verify hardware key' : 'Verify key or passkey'}</button>
  </div>;
}
